export default __webpack_public_path__ + "static/media/pt-icon-active.19c8885b.svg";